import * as React from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

interface CustomDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  tableData: {
    rowHeaders: string[];
    standard: string[];
    premium: string[];
    business: string[];
  };
}

const CustomDialog: React.FC<CustomDialogProps> = ({
  open,
  onClose,
  title,
  tableData,
}) => {
  return (
    <BootstrapDialog onClose={onClose} aria-labelledby="custom-dialog-title" open={open}>
      <DialogTitle sx={{ m: 0, p: 2 }} id="custom-dialog-title">
        {title}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <TableContainer component={Paper}>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell></TableCell>
                <TableCell align="center">Standard</TableCell>
                <TableCell align="center">Premium</TableCell>
                <TableCell align="center">Business</TableCell>
              </TableRow>
              {tableData.rowHeaders.map((row, index) => (
                <TableRow key={row}>
                  <TableCell component="th" scope="row">
                    {row}
                  </TableCell>
                  <TableCell align="center">{tableData.standard[index]}</TableCell>
                  <TableCell align="center">{tableData.premium[index]}</TableCell>
                  <TableCell align="center">{tableData.business[index]}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </BootstrapDialog>
  );
};

export default CustomDialog;